import React, {TouchEventHandler} from "react";
const classNames = require('classnames');

interface LoadingProps {
    style?:string,
    show:boolean
}

const Loading:React.FC<LoadingProps> = ({style='white',show}) => {

    const touchEventHandler:TouchEventHandler = (e) => {
        e.stopPropagation()
        e.preventDefault()
    }

    return show ? <div className={classNames("loading",style)} onTouchStart={ touchEventHandler }>
        <div className="loader">
            <div className="elm"/>
            <div className="elm"/>
        </div>
    </div> : null
}

export default Loading;
